module.exports = __webpack_public_path__ + "img/card-gray-edge.1ae58805.svg";